import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import LockIcon from '@mui/icons-material/Lock';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
  borderRadius: '24px',
  padding: '48px 32px',
  boxShadow: '0 20px 40px rgba(0,0,0,0.08), 0 8px 16px rgba(0,0,0,0.04)',
  border: '1px solid rgba(0,0,0,0.04)',
  textAlign: 'center',
  maxWidth: '480px',
  margin: '0 auto',
}));

const StyledButton = styled(Button)(({ theme, buttontype }) => ({
  borderRadius: '16px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '16px',
  padding: '14px 28px',
  minWidth: '140px',
  boxShadow: buttontype === 'primary' 
    ? '0 8px 24px rgba(25, 118, 210, 0.3)' 
    : '0 8px 24px rgba(220, 53, 69, 0.3)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: buttontype === 'primary' 
      ? '0 12px 32px rgba(25, 118, 210, 0.4)' 
      : '0 12px 32px rgba(220, 53, 69, 0.4)',
  },
  '&:active': {
    transform: 'translateY(0px)',
  }
}));

const IconContainer = styled(Box)({
  background: 'linear-gradient(145deg, #ff6b6b, #ee5a52)',
  borderRadius: '50%',
  width: '120px',
  height: '120px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 32px',
  boxShadow: '0 16px 32px rgba(238, 90, 82, 0.3)',
  '& svg': {
    fontSize: '48px',
    color: 'white',
  }
});

export function ForbiddenPage() {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  const handleLogout = () => {
    // Clear any stored authentication data
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    // Redirect to login page
    window.location.href = '/login';
  };

  return (
    <Container maxWidth="md">
      <Box 
        display="flex" 
        alignItems="flex-start" 
        justifyContent="center" 
        mt={10}
        py={4}
      >
        <StyledPaper elevation={0}>
          <IconContainer>
            <LockIcon />
          </IconContainer>
          
          <Typography 
            variant="h3" 
            gutterBottom
            sx={{
              fontWeight: 700,
              color: '#2c3e50',
              marginBottom: '16px',
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }
            }}
          >
            403 Forbidden
          </Typography>
          
          <Typography 
            variant="h6" 
            sx={{
              color: '#6c757d',
              marginBottom: '40px',
              lineHeight: 1.6,
              fontSize: { xs: '1rem', sm: '1.125rem' }
            }}
          >
            Oops! You don't have permission to access this page.
            <br />
            Let's get you back on track.
          </Typography>
          
          <Box 
            display="flex" 
            gap={2} 
            justifyContent="center"
            flexWrap="wrap"
            sx={{ mt: 4 }}
          >
            <StyledButton
              variant="contained"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
              buttontype="primary"
              sx={{
                background: 'linear-gradient(145deg, #1976d2, #1565c0)',
                color: 'white',
                '&:hover': {
                  background: 'linear-gradient(145deg, #1565c0, #0d47a1)',
                }
              }}
            >
              Go Home
            </StyledButton>
            
            <StyledButton
              variant="contained"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              buttontype="secondary"
              sx={{
                background: 'linear-gradient(145deg, #dc3545, #c82333)',
                color: 'white',
                '&:hover': {
                  background: 'linear-gradient(145deg, #c82333, #a71e2a)',
                }
              }}
            >
              Log Out
            </StyledButton>
          </Box>
        </StyledPaper>
      </Box>
    </Container>
  );
}